import { Navigate, Outlet } from 'react-router-dom';
import { useProductsContext } from '../../context/ProductsContext';

// Gates the Commissions admin page on write access to commission reports
// (admin or finance, per the permissions matrix). Separate from AdminRoute
// so finance users can reach this page without unlocking other admin pages.
export default function CommissionsAdminRoute() {
  const { permissions } = useProductsContext();

  if (!permissions.canManageCommissions) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
